export const getInitialState = () => ({
    fetchStatus: "initial",
    order: undefined,
    orderCreated: undefined,
    addOnOrder: undefined,
    error: undefined,
    orderCreatedByPriceChange: false
});
